module.exports = __webpack_public_path__ + "OpenSans-Italic.525074686dfb8aa36b1b.woff";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/Italic/OpenSans-Italic.woff
// module id = ../../../../npm-font-open-sans/fonts/Italic/OpenSans-Italic.woff
// module chunks = styles